import React, { Component } from 'react';
import emailjs from 'emailjs-com';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

class ContactForm extends Component {

  constructor(props){
    super(props);
    this.state = { 
      btnLabel: "Send",
      response: "",
      isSending: false,
      name: "",
      email: "",
      message: ""
    }
    this.sendEmail = this.sendEmail.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    if (e.target.name === "user_name") {
      this.setState({ name: e.target.value})
    } else if (e.target.name === "user_email") {
      this.setState({ email: e.target.value})
    } else if (e.target.name === "message") {
      this.setState({ message: e.target.value})
    }
  }

  sendEmail(e) {
    e.preventDefault();
    this.setState({ 
      isSending: true,
      btnLabel: "Sending..." 
    })
    emailjs.sendForm('service_f9sf2ib', 'template_a3odt8g', e.target, 'user_mqHgO3B1NUDw1g1nH0MBV')
      .then((result) => {
          console.log(result.text);
          this.setState({ 
            btnLabel: "Send" ,
            response: "Thanks for your message. I'll get back to you shortly!",
            name: "",
            email: "",
            message: "",
            isSending: false
          })
      }, (error) => {
          console.log(error.text);
          this.setState({ 
            btnLabel: "Send",
            response: error.text,
            isSending: false
          })
      });
  }

  render() {
    return (
      <div>
        <form className="contact-form" onSubmit={this.sendEmail}>
          <input type="hidden" name="contact_number" />
          <input type="text" name="user_name" placeholder="Name" value={this.state.name} onChange={(e) => this.handleChange(e)} required />
          <input type="email" name="user_email" placeholder="Email" value={this.state.email} onChange={(e) => this.handleChange(e)} required />
          <textarea name="message" placeholder="message" value={this.state.message} onChange={(e) => this.handleChange(e)} required />
          <div className="flex">
            <div className="contact-form__response">{this.state.response}</div>
            <button type="submit" value="submit" id="button" className="btn submit">
              {this.state.btnLabel} {!this.state.isSending && <FontAwesomeIcon icon={faArrowRight} alt=""/>}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default ContactForm